import DOM from 'quickdom'


export cropContainer = DOM.template(
	['div'
		ref: 'cropContainer'
	]
)

export cropButton = DOM.template(
	['div'
		ref: 'cropButton'
		style:
			display: 'inline-block'
			padding: '17px 30px'
			backgroundColor: '#FAC507'
			borderRadius: 5
			fontSize: 15
			fontWeight: 600
			color: 'white'
			cursor: 'pointer'
			userSelect: 'none'
		
		events: click: ()->
			@related.updateFromCroppie()
	
	'Save Photo']
)

export cropRotate = DOM.template(
	['div'
		ref: 'cropRotate'
		style:
			position: 'relative'
			width: 52
			height: 52
			backgroundColor: '#bebebe'
			borderRadius: 5
		
		computers: action: (@action)->
			@style("margin-#{if @action is 'left' then 'right' else 'left'}", 10)
			switch @action
				when 'left' then @firstChild.text = 'E'
				when 'right' then @firstChild.text = 'F'
		
		events: click: ()->
			@related.croppie.rotate(switch @action
				when 'left' then 90
				when 'right' then -90
			)
		
		['i'
			style:
				position: 'absolute'
				top: '50%'
				left: 0
				right: 0
				width: '100%'
				textAlign: 'center'
				transform: 'translateY(-50%)'
				fontSize: 30
				lineHeight: 1
				color: 'white'
		]
	]
)

export cropActions = DOM.template(
	['div'
		ref: 'cropActions'
		style:
			textAlign: 'center'
			marginTop: 20
			display: 'flex'
			alignItems: 'center'
			justifyContent: 'center'
			flexWrap: 'nowrap'
		
		cropRotate.extend(data:action:'left')
		cropButton
		cropRotate.extend(data:action:'right')
	]
)

export editPopup = DOM.template(
	['div'
		ref: 'editPopup'
		style:
			boxSizing: 'border-box'
			width: '100%'
			maxWidth: 400
			backgroundColor: 'white'
			borderRadius: 5
			padding: '20px'
			cursor: 'pointer'
		
		cropContainer
		cropActions
	]
)


export photoIcon = DOM.template(
	['*svg'
		attrs:
			viewBox: '0 0 548.2 548.2'
			tabindex: -1
			focusable: false
		style:
			width: '100%'
			height: '100%'
			outline: 'none'

		['*path'
			attrs:
				tabindex: -1
				focusable: false
				d: 'M534.8 68.2c-8.9-8.9-19.7-13.4-32.3-13.4H45.7c-12.6 0-23.3 4.5-32.3 13.4C4.5 77.2 0 87.9 0 100.5v347.2c0 12.6 4.5 23.3 13.4 32.3 9 8.9 19.7 13.4 32.3 13.4h456.8c12.6 0 23.3-4.5 32.3-13.4 8.9-8.9 13.4-19.7 13.4-32.3V100.5C548.2 87.9 543.7 77.2 534.8 68.2zM511.6 447.7c0 2.5-0.9 4.6-2.7 6.4 -1.8 1.8-4 2.7-6.4 2.7H45.7c-2.5 0-4.6-0.9-6.4-2.7 -1.8-1.8-2.7-3.9-2.7-6.4V100.5c0-2.5 0.9-4.6 2.7-6.4 1.8-1.8 4-2.7 6.4-2.7h456.8c2.5 0 4.6 0.9 6.4 2.7 1.8 1.8 2.7 3.9 2.7 6.4V447.7L511.6 447.7zM127.9 237.5c15.2 0 28.2-5.3 38.8-16 10.7-10.7 16-23.6 16-38.8 0-15.2-5.3-28.2-16-38.8 -10.7-10.7-23.6-16-38.8-16 -15.2 0-28.2 5.3-38.8 16 -10.7 10.7-16 23.6-16 38.8 0 15.2 5.3 28.2 16 38.8C99.7 232.2 112.7 237.5 127.9 237.5z'
		]
		['*polygon'
			attrs:
				tabindex: -1
				focusable: false
				points: '210.1 319.8 164.5 274.1 73.1 365.4 73.1 420.3 475.1 420.3 475.1 292.4 356.3 173.6 '
		]
	]
)

export remove = DOM.template(
	['div'
		ref: 'remove'
		style:
			position: 'absolute'
			top: 6
			right: 6
			display: 'none'
			width: 20
			height: 20
			backgroundColor: 'black'
			borderRadius: '50%'
			textAlign: 'center'
			cursor: 'pointer'
			$filled: $hovering:
				display: 'block'


		['*svg'
			attrs:
				viewBox: '0 0 21.9 21.9'
				tabindex: -1
				focusable: false
			style:
				width: 8
				height: 8
				outline: 'none'
				fill: 'white'
				color: 'white'

			['*path'
				attrs:
					tabindex: -1
					focusable: false
					d: 'M14.1,11.3c-0.2-0.2-0.2-0.5,0-0.7l7.5-7.5c0.2-0.2,0.3-0.5,0.3-0.7s-0.1-0.5-0.3-0.7l-1.4-1.4C20,0.1,19.7,0,19.5,0  c-0.3,0-0.5,0.1-0.7,0.3l-7.5,7.5c-0.2,0.2-0.5,0.2-0.7,0L3.1,0.3C2.9,0.1,2.6,0,2.4,0S1.9,0.1,1.7,0.3L0.3,1.7C0.1,1.9,0,2.2,0,2.4  s0.1,0.5,0.3,0.7l7.5,7.5c0.2,0.2,0.2,0.5,0,0.7l-7.5,7.5C0.1,19,0,19.3,0,19.5s0.1,0.5,0.3,0.7l1.4,1.4c0.2,0.2,0.5,0.3,0.7,0.3  s0.5-0.1,0.7-0.3l7.5-7.5c0.2-0.2,0.5-0.2,0.7,0l7.5,7.5c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3l1.4-1.4c0.2-0.2,0.3-0.5,0.3-0.7  s-0.1-0.5-0.3-0.7L14.1,11.3z'
			]
		]
	]
)

export placeholder = DOM.template(
	['div'
		ref: 'placeholder'
		style:
			position: 'absolute'
			left: 0
			right: 0
			top: '50%'
			transform: 'translateY(-50%)'
			width: 40
			height: 40
			margin: '0 auto'
			fill: '#82878D'
			$filled:
				display: 'none'
		
		photoIcon
	]
)

export imageFile = DOM.template(
	['img'
		ref: 'img'
		style:
			position: 'absolute'
			left: 0
			right: 0
			top: '50%'
			transform: 'translateY(-50%)'
			width: 'auto'
			height: 'auto'
			maxHeight: '100%'
			maxWidth: '100%'
			margin: '0 auto'
	]
)


export input = DOM.template(
	['input'
		ref: 'input'
		attrs: type: 'file'
		style:
			marginLeft: 20
	]
)


export default DOM.template(
	['div'
		ref: 'field'
		style:
			# display: 'none'
			display: 'inline-block'
			# $visible:
			$showError:
				animation: '0.2s fieldErrorShake'
		stateTriggers:
			hovering: {on:'mouseenter', off:'mouseleave', bubbles:false, force:true}

		['div'
			ref: 'label'
			style:
				marginBottom: 5
				fontSize: 13
				fontWeight: 500
				fontFamily: 'din'
				$showError:
					color: '#cc4820'
		]
		
		['div'
			ref: 'help'
			style:
				fontSize: 12
				fontWeight: 400
				color: '#909090'
		]

		['div'
			ref: 'innerwrap'
			style:
				display: 'flex'
				alignItems: 'center'
				width :'100%'
			
			['div'
				ref: 'imagearea'
				attrs:
					title: 'Change/Set Image'
				style:
					flexShrink: 0
					position: 'relative'
					width: (field)-> field.settings.size
					height: (field)-> field.settings.size
					backgroundColor: 'white'
					boxSizing: 'border-box'
					border: '1px solid #d3d3d3'
					cursor: 'pointer'
					overflow: 'hidden'
				events: click: ()-> @next.raw.click()


				placeholder
				imageFile
				remove
			]

			input
		]
		
		
	]
)

